export const ExercisePrescriptionTypes = Object.freeze({
  REPETITION: "repetition",
  DURATION: "duration",
  DISTANCE: "distance",
  INTERVAL: "interval",
});

export const ExercisePrescriptionLabels = {
  [ExercisePrescriptionTypes.REPETITION]: "Reps / Sets",
  [ExercisePrescriptionTypes.DURATION]: "Duration",
  [ExercisePrescriptionTypes.DISTANCE]: "Distance",
  [ExercisePrescriptionTypes.INTERVAL]: "Intervals (HIIT)",
};

export const ExercisePrescriptionCanonicalFields = {
  [ExercisePrescriptionTypes.REPETITION]: {
    numeric: [],
  },
  [ExercisePrescriptionTypes.DURATION]: {
    numeric: ["durationSeconds"],
    unit: "seconds",
  },
  [ExercisePrescriptionTypes.DISTANCE]: {
    numeric: ["distanceKilometers"],
    unit: "kilometers",
  },
  [ExercisePrescriptionTypes.INTERVAL]: {
    numeric: [
      "intervalWorkSeconds",
      "intervalRestSeconds",
      "intervalRounds",
    ],
    unit: "seconds",
  },
};

export const DEFAULT_EXERCISE_PRESCRIPTION_TYPE =
  ExercisePrescriptionTypes.REPETITION;

export const isTimedPrescription = (prescriptionType) =>
  prescriptionType === ExercisePrescriptionTypes.DURATION;

export const isDistancePrescription = (prescriptionType) =>
  prescriptionType === ExercisePrescriptionTypes.DISTANCE;

export const isIntervalPrescription = (prescriptionType) =>
  prescriptionType === ExercisePrescriptionTypes.INTERVAL;

export const requiresCanonicalField = (prescriptionType) =>
  prescriptionType !== ExercisePrescriptionTypes.REPETITION;

export default {
  ExercisePrescriptionTypes,
  ExercisePrescriptionLabels,
  ExercisePrescriptionCanonicalFields,
  DEFAULT_EXERCISE_PRESCRIPTION_TYPE,
  isTimedPrescription,
  isDistancePrescription,
  isIntervalPrescription,
  requiresCanonicalField,
};

